import gsap from "gsap";
import { enableScrollingForOverlay, disableScrollingForOverlay } from "~/js/components/overlay/helper";

let navItems:HTMLCollectionOf<Element>;

let mobileNavEl:HTMLElement|null;
let mobileNavContainerEl:HTMLElement|null|undefined;
let mobileNavExpandedEl:HTMLElement|null|undefined;
let mobileNavExpandedBgEl:HTMLElement|null|undefined;
let mobileNavExpandedContentEl:HTMLElement|null|undefined;
let mobileNavExpandedContentBgEl:HTMLElement|null|undefined;
let mobileNavOpenBtnEl:HTMLElement|null|undefined;
let mobileNavCloseBtnEl:HTMLElement|null|undefined;

let headerEl:HTMLElement|null;
let headerObserver:IntersectionObserver;

let mobileMarkerEl:HTMLElement|null = null;

let openMobileNavTL:GSAPTimeline = gsap.timeline({
  paused: true,
  onStart: () => {
    mobileNavExpandedEl?.classList.remove('hidden');
    mobileNavContainerEl?.classList.add('opened');
  }
});
let closeMobileNavTL:GSAPTimeline = gsap.timeline({
  paused: true,
  onComplete: () => {
    mobileNavExpandedEl?.classList.add('hidden');
    mobileNavContainerEl?.classList.remove('opened');
  }
});

let desktopNavEl:HTMLElement|null;
let desktopNavSubItemsContainerEl:HTMLElement|null;
let desktopNavSubItemsEl:HTMLElement|null;
let desktopNavSubItems:HTMLCollectionOf<Element>;
let desktopSubItemIndex:number|null = null;

interface subNavItemType {
  containerEl: HTMLElement|null;
  subNavContainerEl: HTMLElement|null;
  onFocus: boolean;
  openTL: GSAPTimeline;
  closeTL: GSAPTimeline;
};

let subNavItems:subNavItemType[] = [];


export function initMobileNav() {
  mobileNavEl = document.querySelector('.nav.nav--mobile');
  mobileNavContainerEl = mobileNavEl?.querySelector('.nav-mobile__container');
  mobileNavExpandedEl = mobileNavEl?.querySelector('.nav-mobile__expanded');
  mobileNavExpandedBgEl = mobileNavEl?.querySelector('.nav-mobile__expanded-bg');
  mobileNavExpandedContentEl = mobileNavEl?.querySelector('.nav-mobile__expanded-content');
  mobileNavExpandedContentBgEl = mobileNavEl?.querySelector('.nav-mobile__expanded-content-bg');

  mobileNavOpenBtnEl = mobileNavEl?.querySelector('.nav-mobile__toggle-btn--open');
  mobileNavCloseBtnEl = mobileNavEl?.querySelector('.nav-mobile__toggle-btn--close');

  mobileNavOpenBtnEl?.addEventListener('click', () => {
    console.log('mobileNavOpenBtn clicked');
    openMobileNav();
  });

  mobileNavCloseBtnEl?.addEventListener('click', () => {
    console.log('mobileNavCloseBtn clicked');
    closeMobileNav();
  });

  // set up animation
  if( mobileNavExpandedEl ) {
    openMobileNavTL.set(mobileNavExpandedEl, {autoAlpha:1});
    // openMobileNavTL.fromTo(mobileNavExpandedEl, {x:'-100%'}, {x:'0%', duration:0.5});
    openMobileNavTL.fromTo(mobileNavExpandedBgEl, {autoAlpha:0}, {autoAlpha:0.6, duration:0.3});
    openMobileNavTL.fromTo(mobileNavExpandedContentBgEl, {x:'-100%'}, {x:'0%', duration:0.3, ease:'power1.out'}, '-=0.25')
    openMobileNavTL.fromTo(mobileNavExpandedContentEl, {x:'-100%'}, {x:'0%', duration:0.4, ease:'power1.out'}, '-=0.4');
    
  

    closeMobileNavTL.to(mobileNavExpandedContentEl, {x:'-100%', duration:0.25, ease:'power1.out'});
    closeMobileNavTL.to(mobileNavExpandedContentBgEl, {x:'-100%', duration:0.25, ease:'power1.out'}, '-=0.25');
    closeMobileNavTL.to(mobileNavExpandedBgEl, {autoAlpha:0, duration:0.2});
    closeMobileNavTL.set(mobileNavExpandedEl, {autoAlpha:0});

    gsap.set(mobileNavExpandedEl, {autoAlpha:0});
  }
}

export function initDesktopNav() {
  desktopNavEl = document.querySelector(".nav.nav--desktop");
  if( desktopNavEl ) {
    desktopNavSubItemsContainerEl = desktopNavEl.querySelector(".nav__content__sub-items-container");

    if( desktopNavSubItemsContainerEl ) {
      desktopNavSubItemsEl = desktopNavSubItemsContainerEl.querySelector(".nav__content__items");
    }

    let navItemsWithSubnav:any[] = [];

    let navItemsEl:HTMLCollectionOf<Element> = desktopNavEl.querySelectorAll(".nav__content .nav-item");
    console.log("navItemsEl:", navItemsEl);

    for( let i=0; i<navItemsEl.length; i++ ) {
      console.log('nav has sub items?', navItemsEl[i].getAttribute("sub-items"));
      
      if( navItemsEl[i].getAttribute("sub-items") == "1" ) {
        // navItemsWithSubnav.push()
        let subNavItemsContainerEl:HTMLElement|null = navItemsEl[i].querySelector(".nav-item__sub-items-container");

        console.log("subNavItemsContainerEl:", subNavItemsContainerEl);

        
        if( subNavItemsContainerEl ) {
          let navItemsInSubNavContainer = subNavItemsContainerEl.querySelectorAll(".nav-item");
          

          let subNavOpenTL:GSAPTimeline = gsap.timeline({
            paused: true,
            onStart: () => {
              adjustSubNavItemsContainerPosition(subNavItemsContainerEl);
            }
          });
          let subNavCloseTL:GSAPTimeline = gsap.timeline({
            paused: true
          });

          subNavOpenTL.fromTo(subNavItemsContainerEl, {autoAlpha:0}, {autoAlpha:1, duration: 0.1});
          subNavOpenTL.fromTo(navItemsInSubNavContainer, {autoAlpha:0, y:'-=10%'}, {autoAlpha:1, y:'0%', stagger:0.05, duration:0.1}, '-=0.1');

          subNavCloseTL.to(subNavItemsContainerEl, {autoAlpha:0, duration:0.1});
          

          let item:subNavItemType = {
            containerEl: navItemsEl[i] as HTMLElement,
            subNavContainerEl: subNavItemsContainerEl,
            onFocus: false,
            openTL: subNavOpenTL,
            closeTL: subNavCloseTL
          };
          subNavItems.push(item);

          navItemsEl[i].addEventListener("mouseleave", () => {
            setTimeout(() => {
              console.log("navItems mouseleave timeout ends");
              console.log(item);
              if( !item.onFocus ) {
                hideSubNavItemsContainer(item);
              }
            }, 100);
          });

          navItemsEl[i].addEventListener("mouseenter", () => {
            // showSubNavItems(parseFloat(navItemsEl[i].getAttribute("nav-item-id")));
            showSubNavItemsContainer(item);
          });

          subNavItemsContainerEl.addEventListener("mouseenter", () => {
            console.log("subNavItem on mouseenter:", item);
            item.onFocus = true;
          })

          subNavItemsContainerEl.addEventListener("mouseleave", () => {
            hideSubNavItemsContainer(item);
          });
        }

        
      }
    }
  }
  
}

function adjustSubNavItemsContainerPosition(subNavItemsContainerEl:HTMLElement) {
  let subNavItemsContainerRect = subNavItemsContainerEl.getBoundingClientRect();

  if( subNavItemsContainerRect.x + subNavItemsContainerRect.width > window.innerWidth ) {
    let right = Math.round(window.innerWidth - (subNavItemsContainerRect.x + subNavItemsContainerRect.width));

    console.log("adjust sub nav right to:", right);
    
    subNavItemsContainerEl.style.right = `${right}px`;
    subNavItemsContainerEl.style.left = 'initial';
    
  }
}

// function showSubNavItems(index:number) {
//   console.log("showSubNavItems()");
//   console.log("index:", index);

//   if( desktopSubItemIndex !== index ) {
//     desktopSubItemIndex = index;

//     if( desktopNavSubItemsContainerEl && desktopNavSubItemsEl ) {
//       desktopNavSubItemsContainerEl.classList.add("visible");

//       let subNavItemsEls = '';
//       console.log(window.navItemsData[index]);

//       if( window.navItemsData[index].subItems ) {
//         for( let i=0; i<window.navItemsData[index].subItems.length; i++ ) {
//           subNavItemsEls += '<a class="nav-item" href="' + window.navItemsData[index].subItems[i]['url'] + '" target="' + window.navItemsData[index].subItems[i]['target'] + '">' + window.navItemsData[index].subItems[i]['label'] + '</a>';
//         }

//         console.log(subNavItemsEls);

//         desktopNavSubItemsEl.innerHTML = subNavItemsEls;
//       }

//       desktopNavSubItemsContainerEl.addEventListener("mouseleave", hideSubNavItems);
//     }
//   }
// }


// function hideSubNavItems() {
//   console.log("hideSubNavItems()");
//   if( desktopNavSubItemsContainerEl ) {
//     desktopSubItemIndex = null;
//     desktopNavSubItemsContainerEl.classList.remove("visible");
//   }
// }

function showSubNavItemsContainer(subNavItem:subNavItemType) {
  console.log("showSubNavItemsContainer();");
  console.log("subNavItemsContainerEl:", subNavItem.subNavContainerEl);

  if( subNavItem ) {
    // subNavItem.onFocus = true;

    subNavItem.closeTL.pause();

    if( subNavItem.subNavContainerEl ) {
      subNavItem.subNavContainerEl.classList.add("visible");
    }

    if( subNavItem.containerEl ) {
      subNavItem.containerEl.classList.add("opened");
    }

    subNavItem.openTL.restart();
  }
  
}

function hideSubNavItemsContainer(subNavItem:subNavItemType) {
  console.log("hideSubNavItemsContainer()");

  if( subNavItem ) {
    subNavItem.onFocus = false;

    subNavItem.openTL.pause();

    if( subNavItem.subNavContainerEl ) {
      subNavItem.subNavContainerEl.classList.remove("visible");
    }

    if( subNavItem.containerEl ) {
      subNavItem.containerEl.classList.remove("opened");
    }

    subNavItem.closeTL.restart();
  }
}

// Init nav elements after document is ready
export function initNav() {
  console.log('initNav()');

  navItems = document.getElementsByClassName('nav-item');

  console.log('navItems', navItems);

  initDesktopNav();

  initMobileNav();

  // const observer = new IntersectionObserver( 
  //   ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
  //   { threshold: [1] }
  // );

  headerEl = document.querySelector('header');
  mobileMarkerEl = document.querySelector('.view-mobile-marker');
  if( mobileMarkerEl !== null ) {
    headerObserver = new IntersectionObserver(
      ([e]) => {
        if( window.innerWidth < 1024 ) {
          // console.log('e.intersectionRatio:', e.intersectionRatio);
          headerEl?.classList.toggle('pinned', e.intersectionRatio < 1);
        }
      },
      {
        threshold: 1.0
      }
    )
    headerObserver.observe(mobileMarkerEl);
  }
  
  
}


function openMobileNav() {
  disableScrollingForOverlay();

  if( closeMobileNavTL ) {
    closeMobileNavTL.pause();
  }

  openMobileNavTL.restart();
}

function closeMobileNav() {
  if( openMobileNavTL ) {
    openMobileNavTL.pause();
  }

  
  closeMobileNavTL.restart();

  enableScrollingForOverlay();
}

